import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
} from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { useTheme } from '@material-ui/core/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarLogo } from './SidebarLogo';

// Logoff acessível de qualquer tela: o botão nativo fica enterrado em
// Settings > aba, então exponho um item "Sair" direto na sidebar.
const SignOutSidebarItem = () => {
  const identityApi = useApi(identityApiRef);
  return (
    <SidebarItem
      icon={ExitToAppIcon}
      text="Sair"
      onClick={() => identityApi.signOut()}
    />
  );
};

// useSidebarOpenState só reflete o estado real quando chamado por um
// componente renderizado DENTRO de <Sidebar>, onde o Provider existe de
// fato. Chamar no componente que retorna <Sidebar> (um nível acima) sempre
// lê o valor default do context, nunca o real.
const SidebarFooter = () => {
  const theme = useTheme();
  const { isOpen } = useSidebarOpenState();

  if (!isOpen) {
    return null;
  }

  return (
    <p
      style={{
        textAlign: 'center',
        fontSize: '0.65rem',
        opacity: 0.5,
        margin: '4px 0 8px',
        color: theme.palette.navigation.color,
        alignSelf: 'stretch',
      }}
    >
      v1.0.1 · by SRE
    </p>
  );
};

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem
          icon={() => item.icon}
          // page:catalog: /catalog puro dá erro (TypeError "Class extends
          // value undefined is not a constructor") num bug do plugin catalog
          // com filtros vazios. Fixando o link nos filtros default (kind
          // component, owned) que sabidamente funcionam.
          to={
            item.node.spec.id === 'page:catalog'
              ? '/catalog?filters[kind]=component&filters[user]=owned&limit=20'
              : item.href
          }
          text={item.title}
        />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            <SidebarItem icon={HomeIcon} to="/" text="Home" />
            {nav.take('page:catalog')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:user-settings')}
            <SignOutSidebarItem />
          </SidebarGroup>
          <SidebarFooter />
        </Sidebar>
      );
    },
  },
});
